import { render, staticRenderFns } from "./list-approved.vue?vue&type=template&id=f2a127ac&scoped=true&"
import script from "./list-approved.vue?vue&type=script&lang=js&"
export * from "./list-approved.vue?vue&type=script&lang=js&"
import style0 from "./list-approved.vue?vue&type=style&index=0&id=f2a127ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a127ac",
  null
  
)

export default component.exports